import { render, staticRenderFns } from "./TabCanceled.vue?vue&type=template&id=774f754c&"
import script from "./TabCanceled.vue?vue&type=script&lang=js&"
export * from "./TabCanceled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports